exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".global-search-item[data-v-5dfc27ac]:hover{background-color:#f0f4f8}.cursor-pointer[data-v-5dfc27ac]{cursor:pointer}", ""]);

// exports
